@use './variables.scss' as *;
// 导出变量
:export {
  namespace: $namespace;
  elNamespace: $elNamespace;
}
